import _ from 'lodash';

const gradientColors = [
  { light: '#EAEFF4', dark: '#D3DFEB' },
  { light: '#F2F5FA', dark: '#E3EEFF' },
  { light: '#F4F1ED', dark: '#E0DAD3' },
  { light: '#EBEBEB', dark: '#DBDBDB' },
  { light: '#EBF0F0', dark: '#E1E8E8' },
];

export const GRADIENT_COLORS_COUNT = gradientColors.length;

export const getTemplateGradientBackground = (colorIndex?: number) => {
  if (_.isNil(colorIndex) || !_.inRange(colorIndex, 0, GRADIENT_COLORS_COUNT)) {
    colorIndex = _.random(0, GRADIENT_COLORS_COUNT - 1);
  }

  return `linear-gradient(180deg, ${gradientColors[colorIndex]?.light}, ${gradientColors[colorIndex]?.dark} 100%)`;
};
